import { replace, isObject, mapValues, isArray, map, isEmpty, isString, chain } from "lodash"
import queryString from "query-string"
import JSURL from "jsurl"

const parseOptions = {
  parseBooleans: true,
  parseNumbers: true,
  arrayFormat: "bracket-separator",
  arrayFormatSeparator: "|",
}

const stringifyOptions = {
  arrayFormat: "bracket-separator",
  arrayFormatSeparator: "|",
  encode: false,
  skipNull: true,
  skipEmptyString: true,
  sort: false,
}

const ENCODED_SINGLE_QUOTE = "`"

// Browsers encode the quotes, so changing it to something that won't get encoded in the query string
const singleQuoteEncoder = (toEncode) => isString(toEncode) ? replace(toEncode, /'/g, ENCODED_SINGLE_QUOTE) : toEncode
const singleQuoteDecoder = (toDecode) => isString(toDecode) ? replace(toDecode, new RegExp(ENCODED_SINGLE_QUOTE, "g"), "'") : toDecode

const encodeSingleQuotes = (toEncode) => {
  if (isArray(toEncode)) {
    if (isEmpty(toEncode)) {
      return null
    }
    return map(toEncode, value => singleQuoteEncoder(value))
  }
  return singleQuoteEncoder(toEncode)
}

const decodeSingleQuotes = (toDecode) => {
  if (isArray(toDecode)) {
    return map(toDecode, value => singleQuoteDecoder(value))
  }
  return singleQuoteDecoder(toDecode)
}

export const getQueryStringState = (overrideParseOptions = {}) => {
  const parsedQS = queryString.parse(window.location.search, { ...parseOptions, ...overrideParseOptions })
  return mapValues(parsedQS, value => {
    const decoded = decodeSingleQuotes(value)
    let result = JSURL.tryParse(decoded, decoded)
    // If we had an array with objects inside, we need to deserialize those
    if (isArray(result)) {
      result = map(result, item => JSURL.tryParse(item, item))
    }
    return result
  })
}

// The following code (and all related functions) was copied to pi-server/helpers/sharedLink.js, so it needs to be updated in both
// places if it changes.
export const stringifyState = (state) => {
  const encodedState = mapValues(state, value => {
    let newValue = value
    // Array is considered as Object, and we don't want JSURL to encode it as stringify will do it better
    if (isObject(value) && !isArray(value)) {
      newValue = JSURL.stringify(value)
    }
    if (isArray(value)) {
      newValue = map(value, item => {
        // If we have objects inside an array, encode them
        if (isObject(item)) {
          // substring gets rid of the item=, which we need to serialize properly
          return stringifyState({ item }).substring(5)
        } else {
          return item
        }
      })
    }
    return encodeSingleQuotes(newValue)
  })
  return queryString.stringify(encodedState, stringifyOptions)
}

export const setQueryStringState = (navigate, state) => {
  navigate(`${window.location.pathname}?${stringifyState(state)}`, { replace: true })
}

export function isKeyInQueryString(key) {
  return chain(getQueryStringState())
    .keys()
    .includes(key)
    .value()
}
